export enum SELECT_ADDRESS_STATES {
  INITIAL = 'initial',
  ADDRESSABLE = 'ADDRESSABLE',
  WAIT_CHECKOUT_STARTING = 'WAIT_CHECKOUT_STARTING',
  WAIT_USER_READY = 'WAIT_USER_READY',
  GET = 'GET',
  GET_WITH_FORM = 'GET_WITH_FORM',
  ADDRESSES_FETCHING = 'ADDRESSES_FETCHING',
  GET_ERROR = 'ERROR',
  GET_SUCCESS = 'GET_SUCCESS',
  NO_ADDRESS_SAVED = 'NO_ADDRESS_SAVED',
  ADDRESS_PREFILLED = 'ADDRESS_PREFILLED',
  ADDRESS_SELECTED = 'ADDRESS_SELECTED',
  ADDRESS_CREATING = 'ADDRESS_CREATING',
  ADDRESS_UPDATING = 'ADDRESS_UPDATING',
}
